import client from "./client";

export type Plan = "full" | "half" | "quarter";
export type Currency = "USD" | "AZN" | "BYN" | "GEL" | "KZT" | "TRY";

export const stripeApi = {
  checkout: (body: { email: string; plan: Plan; currency: Currency }) =>
    client.post<{ url: string; sessionId: string }>("/stripe/checkout", body),

  remainder: () =>
    client.post<{ url: string; sessionId: string }>("/stripe/remainder"),

  credentials: (sessionId: string) =>
    client.get<{ userId: number; username: string; password: string; token: string }>(
      `/stripe/session/${sessionId}/credentials`,
    ),
};
